module.exports = __webpack_public_path__ + "img/162.79f6efbb.jpg";